import { OverlayConfig } from '@angular/cdk/overlay';
import { InjectionToken } from '@angular/core';
import { WizardControl, WizardDef } from './model/wizard.model';

export const DEFAULT_OVERLAY_CONFIGS: Partial<OverlayConfig> = {
  hasBackdrop: true,
  backdropClass: 'cdk-overlay-dark-backdrop',
  panelClass: ['table-modals', 'modal', 'is-active'],
};
export const WIZARD_DEF_TOKEN = new InjectionToken<WizardDef>('WIZARD_DEF_TOKEN');
export const WIZARD_CONTROLS = new InjectionToken<WizardControl>('WIZARD_CONTROLS');
